export const seo = {
    home: {
        title: 'Dynamix Çelik Fiber | Yüksek Performanslı Beton Donatısı - Çorlu, Tekirdağ',
        description: 'Dynamix Çelik Fiber, Çorlu, Tekirdağ\'da beton donatısı için yüksek performanslı kancalı uçlu çelik fiberler üretmektedir. Baraj inşaatı, tünelcilik, endüstriyel zeminler ve dünya çapındaki altyapı projeleri için mühendislik çözümleri.',
        keywords: 'çelik fiber, kancalı uçlu çelik fiber, beton donatısı, Dynamix, Çorlu çelik fiber, Tekirdağ inşaat, baraj inşaatı, tünel güçlendirme, endüstriyel zemin, püskürtme beton, UHPC, altyapı, inşaat malzemeleri',
        schema: {
            webPage: {
                name: 'Dynamix Çelik Fiber - Ana Sayfa',
                description: 'Beton yapılar için yüksek performanslı çelik fiber donatı'
            }
        }
    },
    product: {
        title: 'Kancalı Uçlu Çelik Fiber Ürünleri | Dynamix - Çorlu, Tekirdağ',
        description: 'Beton için birinci sınıf kalitede kancalı uçlu çelik fiber donatı. Teknik özellikler: 30-60mm uzunluk, 0.5-1.2mm çap, >1100 MPa çekme dayanımı. ASTM A820 uyumlu. Baraj inşaatı, tünelcilik ve endüstriyel zeminler için idealdir.',
        keywords: 'kancalı uçlu çelik fiber, çelik fiber özellikleri, beton donatı ürünü, ASTM A820, yüksek çekme dayanımlı fiber, soğuk çekilmiş çelik fiber, Dynamix ürünleri, inşaat malzemeleri Tekirdağ'
    },
    applications: {
        title: 'Çelik Fiber Uygulamaları | Baraj, Tünel, Endüstriyel Zemin - Dynamix',
        description: 'Dynamix çelik fiber uygulamalarını keşfedin: baraj inşaatı, tünelcilik ve yeraltı çalışmaları, endüstriyel zeminler, prekast elemanlar, kaplamalar, temel plakaları, su depoları ve patlamaya dayanıklı yapılar. Altyapı projeleri için mühendislik çözümleri.',
        keywords: 'çelik fiber uygulamaları, baraj inşaatı güçlendirme, tünel püskürtme beton, endüstriyel zemin betonu, prekast beton fiber, kaplama güçlendirme, temel plakası fiberi, altyapı uygulamaları, inşaat çözümleri',
        schema: {
            webPage: {
                name: 'Çelik Fiber Uygulamaları',
                description: 'İnşaat projelerinde Dynamix çelik fiberin kapsamlı uygulamaları'
            }
        }
    },
    about: {
        title: 'Dynamix Çelik Fiber Hakkında | Hikayemiz, Misyonumuz ve Değerlerimiz - Çorlu, Tekirdağ',
        description: 'Dynamix Çelik Fiber hakkında bilgi edinin: Çorlu, Tekirdağ\'da yenilikçi çelik fiber üreticisi. Misyonumuz, dayanıklı beton yapılar için yüksek kaliteli çelik fiber çözümleri sunmaktır. Kalite mükemmelliği, yenilikçilik, dürüstlük ve sürdürülebilirliğe bağlıyız.',
        keywords: 'Dynamix hakkında, çelik fiber üreticisi, Çorlu Tekirdağ şirketi, inşaat malzemeleri şirketi, çelik fiber inovasyonu, kaliteli üretim, sürdürülebilir inşaat, mühendislik çözümleri',
        schema: {
            webPage: {
                name: 'Dynamix Çelik Fiber Hakkında',
                description: 'Şirket bilgileri, misyon, vizyon ve temel değerler'
            }
        }
    },
    contact: {
        title: 'Dynamix Çelik Fiber İletişim | Bize Ulaşın - Çorlu, Tekirdağ',
        description: 'Çorlu, Tekirdağ\'daki Dynamix Çelik Fiber ile iletişime geçin. Adres: Şeyh Sinan, Hüsmen Kalfa Sk. No:5/33, 59850 Çorlu/Tekirdağ. Telefon: +90 530 095 97 41. E-posta: info@dynamixsteelfiber.com. Çalışma saatleri: Pzt-Cum 08:00-18:00, Cmt 09:00-14:00.',
        keywords: 'Dynamix iletişim, çelik fiber tedarikçisi iletişim, Çorlu Tekirdağ adres, inşaat malzemeleri sorgulama, çelik fiber teklifi, Dynamix telefon numarası, Dynamix e-posta'
    }
};
